import { Injectable } from '@angular/core';

@Injectable()
export class AppService {
  private _flags: { [key: string]: boolean } = {};

  constructor() {}

  public setFlag(flag: string, value: boolean): void {
    this._flags[flag] = value;
  }

  public getFlag(flag: string): boolean {
    return this._flags[flag] || false;
  }

  public hasFlag(flag: string): boolean {
    return this._flags.hasOwnProperty(flag);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/app.service.ts